import React from "react";
import { createPortal } from 'react-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import useConfirm from 'hooks/useConfirm';

const ConfirmDialog = () => {
    const { onConfirm, onCancel, confirmState } = useConfirm();

    const component = confirmState.show ? (
        <Dialog aria-labelledby="draggable-dialog-title" open={confirmState.show} fullWidth={true}
            maxWidth={confirmState?.width && confirmState.width}>

            <DialogTitle id="draggable-dialog-title">
                {confirmState?.title && confirmState.title}
            </DialogTitle>

            <DialogContent>
                <Typography>{confirmState?.text && confirmState.text}</Typography>
            </DialogContent>

            <DialogActions>
                {
                    confirmState?.showReject && <Button onClick={onCancel} color="secondary" variant="outlined">
                        {confirmState?.rejectLabel && confirmState.rejectLabel}
                    </Button>
                }

                <Button onClick={onConfirm} color="primary" variant="outlined">
                    {confirmState?.confirmLabel && confirmState.confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    ) : null;

    return createPortal(component, document.body);
};

export default ConfirmDialog;